import React from 'react';
import { MediaItem } from '../../api/structs/media';
import { WaitingThumbnail, FailedThumbnail } from '../ui/Thumbnail';
import { getMediaFileUrl, getMediaThumbUrl } from './sections/MediaEditorSection.helpers';
import MediaThumbImage from './MediaThumbImage';

interface ClipCollapsedThumbnailsProps {
  images: MediaItem[];
}

const ClipCollapsedThumbnails: React.FC<ClipCollapsedThumbnailsProps> = ({ images }) => (
  <div className="max-w-full flex gap-2 overflow-x-auto pb-2">
    {images.slice(0, 5).map((img) => {
      const url = img.file_url || '';
      if (url.includes('_waiting')) {
        return <WaitingThumbnail key={img.id} sizeClass="w-16 h-16" className="" />;
      }
      if (url.includes('_failed')) {
        return <FailedThumbnail key={img.id} sizeClass="w-16 h-16" className="" />;
      }
      return (
        <div key={img.id} className="w-16 h-16 rounded overflow-hidden bg-slate-700 shrink-0">
          <MediaThumbImage
            thumbUrl={getMediaThumbUrl(img)}
            originalUrl={getMediaFileUrl(img)}
            alt=""
            className="w-full h-full"
            imgClassName="w-full h-full object-cover"
          />
        </div>
      );
    })}
    {images.length > 5 && (
      <div className="w-16 h-16 bg-slate-700 rounded flex items-center justify-center text-slate-400 text-sm">
        +{images.length - 5}
      </div>
    )}
  </div>
);

export default ClipCollapsedThumbnails;
